<div class="header-container" [class.header-container--embedded]="embedded" [hidden]="!embedded && !barService.display">
    <div class="refresh-container">
      <app-ui-toolbar-button class="refresh-button" (pressed)="refreshReferrals()">
        <i class="fas fa-sync-alt" [class.rotating]="isRefreshing"></i>
        <span>Refresh<span class="refresh-button__suffix"> Referrals</span></span>
      </app-ui-toolbar-button>
      <span class="last-updated">
        <span>Last Updated:</span>
        <span>{{ (barService.lastUpdate | date: 'short') || '' }}</span>
      </span>
    </div>
    <div class="search-bar">
      <app-search-box #searchBox (search)="onSearch($event)"></app-search-box>
    </div>
  </div>
